export function minted (howMany: number): void {
  try {
    (window as any).plausible('Minted', { props: { howMany } });
  } catch (e) {

  }
}
